"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigationHistory = void 0;
var useNavigationHistory_1 = require("./useNavigationHistory");
Object.defineProperty(exports, "useNavigationHistory", { enumerable: true, get: function () { return useNavigationHistory_1.useNavigationHistory; } });
